export const isIE = () => {
  if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    !!document.documentMode === true
  ) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/detect_ie.js